// extracted by mini-css-extract-plugin
export default {"overlay":"Qy-z","bodyOpen":"Ry-z","content":"Sy-z","header":"Ty-z","close":"Uy-z","closeNoHeading":"Vy-z"};